<br><br>
<div>
  <div>
    <div style="display: block">
      <canvas baseChart
        [datasets]="barChartDataDasCol"
        [labels]="barChartLabelsDasCol"
        [options]="barChartOptionsClumn"
        [plugins]="barChartPluginsDasCol"
        [legend]="barChartLegendDasCol">
      </canvas>
      <!-- <canvas baseChart
        [datasets]="barChartData"
        [labels]="barChartLabels"
        [options]="barChartOptions"
        [plugins]="barChartPlugins"
        [legend]="barChartLegend"
        [chartType]="barChartType">
      </canvas> -->
    </div>
  </div>
</div>
